import { useEffect } from "react";
import { useRoute, useLocation } from "wouter";
import { useDocumentViewer } from "@/contexts/DocumentViewerContext";
import { useMastermind } from "@/contexts/MastermindContext";

export function SourceViewerPage() {
  const [match, params] = useRoute("/source/:id");
  const [, setLocation] = useLocation();
  const { openItem } = useDocumentViewer();
  const { setIsCollapsed } = useMastermind();

  useEffect(() => {
    if (match && params?.id) {
      openItem(params.id, "source");
      setIsCollapsed(false);
      setLocation("/library");
    }
  }, [match, params, openItem, setLocation, setIsCollapsed]);

  return null;
}

export function DocumentViewerPage() {
  const [match, params] = useRoute("/document/:id");
  const [, setLocation] = useLocation();
  const { openItem } = useDocumentViewer();
  const { setIsCollapsed } = useMastermind();

  useEffect(() => {
    if (match && params?.id) {
      openItem(params.id, "document");
      setIsCollapsed(false);
      setLocation("/library");
    }
  }, [match, params, openItem, setLocation, setIsCollapsed]);

  return null;
}
